(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('systemLog', {
            parent: 'module',
            url: '/systemLog',
            data: {
                authorities: ['ROLE_SYSTEM_LOG']
            },
            views: {
                'content': {
                    templateUrl: 'app/setting/systemLog/systemLog.html',
                    controller: 'SystemLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        })
    }
})();
